import {isEmpty} from 'lodash';
import {Logger} from '../../../utils/Logger';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {AutoInvestLoanViewModel} from './auto-invest-loan-view-model';
import {GaugedInvestment} from '../../../model/gauged-investment.model';
import {InvestmentNavigator} from '../../../utils/investment-navigator';
import {AutoInvestLoanViewModelMapper} from './auto-invest-loan-view-model-mapper';
import {ManualinvestdetailComponent} from '../../manualinvestdetail/manualinvestdetail.component';
import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';

@Component({
    selector: 'app-auto-invest-loans',
    templateUrl: './auto-invest-loans.component.html',
    styleUrls: ['../../../../assets/styles/finzy-styles.scss', './auto-invest-loans.component.scss']
})
export class AutoInvestLoansComponent implements AfterViewInit, OnChanges {
    @Input()
    readonly investmentAmount: number;
    @Input()
    readonly gaugedInvestments: GaugedInvestment[] = [];
    readonly tableDataSource: MatTableDataSource<AutoInvestLoanViewModel> = new MatTableDataSource();
    @Output()
    readonly onInvestmentConfirmed = new EventEmitter<void>();
    @Output()
    readonly onInvestmentCancelled = new EventEmitter<void>();
    displayedColumns: any = ['roi', 'rating', 'loan_amount', 'filled_percentage', 'loan_data', 'fund_allocation'];
    public loader = false;
    lender50kLimitDeclarationCheck = false;
    @ViewChild(MatSort)
    readonly sort: MatSort;
    @ViewChild(MatPaginator)
    readonly paginator: MatPaginator;
    private readonly dialog: MatDialog;
    private readonly manualInvestNavigator: InvestmentNavigator;
    private readonly autoInvestLoanViewModelMapper: AutoInvestLoanViewModelMapper;

    constructor(dialog: MatDialog, manualInvestNavigator: InvestmentNavigator,
                autoInvestLoanViewModelMapper: AutoInvestLoanViewModelMapper) {
        this.dialog = dialog;
        this.manualInvestNavigator = manualInvestNavigator;
        this.autoInvestLoanViewModelMapper = autoInvestLoanViewModelMapper;
    }

    ngAfterViewInit(): void {
        this.tableDataSource.sort = this.sort;
        this.tableDataSource.paginator = this.paginator;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.gaugedInvestments && changes.gaugedInvestments.currentValue) {
            this.tableDataSource.data = changes.gaugedInvestments.currentValue.map(gaugedInvestment => {
                return this.autoInvestLoanViewModelMapper.convertToAutoInvestLoanViewModel(gaugedInvestment);
            });
        }
    }

    async manualInvest(): Promise<void> {
        await this.manualInvestNavigator.navigateToManualInvestListingPage(this.investmentAmount);
    }

    viewLoanDetails(loan) {
        this.dialog.open(ManualinvestdetailComponent, {data: loan, panelClass: 'manual-invest-details-dialog'});
    }

    autoInvest(gaugedInvestments) {
        if (!isEmpty(gaugedInvestments) && !this.lender50kLimitDeclarationCheck) {
            Logger.log(`Lender's 50K limit declaration is not given. Not proceeding with auto invest.`);
            return;
        }

        this.loader = true;
        this.onInvestmentConfirmed.emit();
    }

    onInvestLaterClicked() {
        this.onInvestmentCancelled.emit();
    }
}